import { Link } from 'react-router-dom';
import type { Movie } from '../../mocks/movies';
import { formatViews } from '../../utils/movies';

interface MovieListRowProps {
  movie: Movie;
  index?: number;
}

export default function MovieListRow({ movie, index }: MovieListRowProps) {
  return (
    <Link
      to={`/detail/${movie.id}`}
      className="group flex gap-3 md:gap-4 p-3 rounded-lg bg-background-50 border border-background-200 hover:border-primary-300 transition-all duration-300 cursor-pointer"
    >
      {typeof index === 'number' && (
        <div className="hidden sm:flex items-center justify-center w-8 shrink-0">
          <span
            className={`font-heading font-extrabold text-lg ${
              index < 3 ? 'text-accent-500' : 'text-foreground-300'
            }`}
          >
            {index + 1}
          </span>
        </div>
      )}
      <div className="w-16 md:w-20 h-24 md:h-28 shrink-0 rounded-md overflow-hidden bg-background-200">
        <img
          src={movie.cover}
          alt={`${movie.title}中文字幕在线观看`}
          title={`${movie.title} - 高清中文字幕`}
          className="w-full h-full object-top object-cover transition-transform duration-500 group-hover:scale-105"
        />
      </div>
      <div className="flex flex-col justify-center gap-1.5 min-w-0 flex-1">
        <div className="flex items-center gap-2">
          <h3 className="font-heading font-semibold text-sm md:text-base text-foreground-950 truncate group-hover:text-primary-600 transition-colors">
            {movie.title}
          </h3>
          <span className="px-1.5 py-0.5 rounded bg-secondary-100 text-secondary-900 text-[10px] font-medium whitespace-nowrap">
            {movie.type === 'movie' ? '电影' : '剧集'}
          </span>
        </div>
        <p className="text-xs text-foreground-500 truncate">
          {movie.genres.join(' · ')} · {movie.region} · {movie.year}
        </p>
        <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2 hidden sm:block">{movie.synopsis}</p>
        <div className="flex items-center gap-3 mt-1 text-[11px] text-foreground-400">
          <span className="flex items-center gap-1 text-accent-600 font-semibold">
            <i className="ri-star-fill" aria-hidden="true"></i>
            {movie.rating.toFixed(1)}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-fire-line text-accent-500" aria-hidden="true"></i>
            {formatViews(movie.views)}
          </span>
          <span className="hidden md:inline">{movie.duration}</span>
        </div>
      </div>
      <div className="hidden sm:flex items-center pr-2">
        <span className="w-9 h-9 flex items-center justify-center rounded-full bg-background-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
          <i className="ri-arrow-right-line text-lg" aria-hidden="true"></i>
        </span>
      </div>
    </Link>
  );
}